<div class="d-flex align-items-center gap-2 opacity-75 auto-save"
     [class.message-on-right]="messagePosition === 'right'"
     [class.text-danger]="!!errorMessage && saveStatus === SaveStatus.Error">
    @switch (saveStatus) {
        @case (SaveStatus.Saving) {
            <small>Saving...</small>
            <i class="fal fa-fw fa-arrows-rotate fa-spin"></i>
        }
        @case (SaveStatus.PendingSave) {
            <small>Waiting to save...</small>
            <i class="fal fa-fw fa-arrows-rotate"></i>
        }
        @case (SaveStatus.Error) {
            <small>
                {{errorMessage}}
                <button adaptButton="refreshLink"
                        adaptStopPropagation
                        class="ms-2"
                        (click)="triggerImmediateSave()">Retry save</button>
            </small>
            <i class="fal fa-fw fa-rotate-exclamation"
               adaptTooltip="Failed to save changes"></i>
        }
        @default {
            @if (saveStatusTextShown) {
                <small>Saved</small>
            }
            <i class="fal fa-fw fa-cloud-check"
               adaptTooltip="Changes are saved"></i>
        }
    }
</div>
